/* eslint-disable @typescript-eslint/naming-convention */

/** Hub attached to a component-option row. */
export type ComponentOptionLocationType = {
  location_id: number
  location_name: string
}

/**
 * `location` comes back either as every hub of the record in one row, or as a
 * single hub with the row repeated per location. Both shapes read the same way.
 */
export type ComponentOptionLocationFieldType =
  | ComponentOptionLocationType
  | ComponentOptionLocationType[]
  | null

export const toHubNames = (location?: ComponentOptionLocationFieldType): string[] =>
  (Array.isArray(location) ? location : [location])
    .map((item) => item?.location_name)
    .filter((name): name is string => Boolean(name))
